import { runInAction } from 'mobx';
import { updateObject } from '../objects';
export const updateFetchedDataState = (state, newValue) => {
    runInAction(() => updateObject(state, newValue));
};
//# sourceMappingURL=update-fetched-data-state.js.map